import { render, staticRenderFns } from "./signinComponent.vue?vue&type=template&id=f67130f2&scoped=true&"
import script from "./signinComponent.vue?vue&type=script&lang=js&"
export * from "./signinComponent.vue?vue&type=script&lang=js&"
import style0 from "./signinComponent.vue?vue&type=style&index=0&id=f67130f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67130f2",
  null
  
)

export default component.exports